// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireQuestionChoiceOptionBehaviourFragmentDoc = `
    fragment questionnaireQuestionChoiceOptionBehaviour on QuestionnaireQuestionChoiceOptionBehaviour {
  __typename
  metal
  ringStyle
  designStyle
  designFeature
  shape
}
    `;